import { DeclinedReason } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface DeclinedReasonsState extends EntityState<DeclinedReason> {}

export const declinedReasonsAdapter: EntityAdapter<DeclinedReason> = createEntityAdapter<DeclinedReason>({
  selectId: (declinedReason: DeclinedReason) => declinedReason.id
});

export const initialState: DeclinedReasonsState = declinedReasonsAdapter.getInitialState({});
export const declinedReasonsFeatureSelector = createFeatureSelector<any>('labourOperations');
export const declinedReasonsSelector = createSelector(
  declinedReasonsFeatureSelector,
  (state: any) => state.declinedReasons
);
export const { selectIds, selectEntities, selectAll, selectTotal } = declinedReasonsAdapter.getSelectors(
  declinedReasonsSelector
);
